import React from 'react';
import { Card, Button, Badge, Collapse, Spinner, Alert } from 'react-bootstrap';
import { Edit2, Building2, MapPin, Phone, AlertTriangle } from 'lucide-react';
import ListingCard from './ListingCard';
import { useListing } from './contexts/ListingContext';
import { useListingActions } from './hooks/useListingActions';

const FacilityCard = ({ facility, facilityIndex, onEdit, onEditListing }) => {
  // Always call hooks at the top
  const { togglePublish } = useListingActions();
  const [open, setOpen] = React.useState(true);
  const { getListingsForFacility, listingsByFacilityId, isFetchingAllListings, errorByFacilityId } = useListing();
  if (!facility) return null;
  const facilityId = facility._id || facility.id;
  const listings = getListingsForFacility ? getListingsForFacility(facilityId) : [];
  const isLoading = isFetchingAllListings || (listingsByFacilityId && listingsByFacilityId[facilityId]?.isLoading);
  const error = errorByFacilityId && errorByFacilityId[facilityId];

  return (
    <Card className="glass-card mb-4 p-3 premium-shadow animate-fade-in">
      <div className="d-flex align-items-center mb-2">
        <Building2 className="me-2 text-primary" />
        <h5 className="fw-bold mb-0 gradient-text">{facility.facilityName || facility.name}</h5>
        <Badge bg={facility.isComplete ? 'success' : 'warning'} className="ms-2">
          {facility.isComplete ? 'Ready' : 'Missing Info'}
        </Badge>
        <Button variant="outline-primary" className="ms-auto me-2" size="sm" onClick={onEdit}>
          <Edit2 size={16} /> Edit Facility
        </Button>
        <Button variant="outline-secondary" size="sm" onClick={() => setOpen(o => !o)}>
          {open ? 'Hide Listings' : 'Show Listings'}
        </Button>
      </div>
      <div className="mb-1 text-muted"><MapPin size={14} className="me-1" />{facility.location}</div>
      {facility.contactPerson && (
        <div className="small text-muted mb-2"><Phone size={13} className="me-1" />{facility.contactPerson.name} &bull; {facility.contactPerson.email} &bull; {facility.contactPerson.phone}</div>
      )}
      <Collapse in={open}>
        <div>
          {isLoading ? (
            <div className="d-flex align-items-center text-info mb-2"><Spinner animation="border" size="sm" className="me-2" /> Loading listings...</div>
          ) : error ? (
            <Alert variant="danger" className="d-flex align-items-center mb-2"><AlertTriangle size={16} className="me-2" /> Error loading listings</Alert>
          ) : (listings && listings.length > 0 ? (
            listings.map((listing, lIdx) => (
              <ListingCard
                key={listing._id || lIdx}
                listing={listing}
                onEdit={() => onEditListing(lIdx)}
                onTogglePublish={() => togglePublish(
                  facilityIndex,
                  lIdx,
                  listing.reviewStatus
                )}
              />
            ))
          ) : (
            <div className="text-muted mb-2">No listings for this facility.</div>
          ))}
        </div>
      </Collapse>
    </Card>
  );
};

export default FacilityCard;
